import * as R from 'ramda';
import errorCodes from '@8base/error-codes';

export const hasForcibleError = R.pathEq(['graphQLErrors', 0, 'code'], errorCodes.ForcibleErrorCode);
